import en from './en';
import ru from './ru';
import bg from './bg';

const translations = {
  en,
  ru,
  bg,
};

export const getTranslation = (lang) => {
  return translations[lang] || translations.en;
};

export default translations;